import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/App";

export default function ImageField({ label, value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError("");
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
    } catch (err) {
      setError(err.response?.data?.detail || "Falha no envio da imagem.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em] text-navy">{label}</p>
      <div className="flex items-center gap-4">
        {value ? (
          <img src={value} alt={label} className="h-16 w-16 border border-navy/15 object-cover" data-testid={`${testid}-preview`} />
        ) : (
          <div className="flex h-16 w-16 items-center justify-center border border-dashed border-navy/25 text-[10px] text-navy/40">sem foto</div>
        )}
        <label className="cursor-pointer border border-navy/20 px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.16em] text-navy transition-colors hover:border-gold hover:text-gold-deep">
          {uploading ? "Enviando…" : "Enviar imagem"}
          <input type="file" accept=".jpg,.jpeg,.png,.webp" className="hidden" data-testid={testid} onChange={upload} />
        </label>
      </div>
      <input
        className="mt-3 w-full border border-navy/20 bg-white px-3 py-2.5 text-xs text-navy"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Caminho da imagem (/media/... ou /api/media/...)"
        data-testid={`${testid}-url`}
      />
      {error && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
}
